import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    HStack,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'

import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import {Pagination, Navigation} from 'swiper/modules'

import Card from './partials/card'
import usePdTagManager from '../../../../hooks/use-pd-tag-manager'

export const TextTilesX4 = (props) => {
    const {typeId, name} = props
    const pdTagManager = usePdTagManager()
    const slidesPerView = useBreakpointValue({base: 1, md: 4, lg: 6})
    const cards = [
        {
            title: props?.title1,
            titleColor: props?.titleColor1 || 'black',
            titleFontFamily: props?.titleFontFamily1 || 'caslon',
            titleTag: props?.titleTag1,
            subheadText: props?.subheadText1,
            subheadTextColor: props?.subheadTextColor1 || 'black',
            subheadTextTag: props?.subheadTextTag1,
            subheadTextFontFamily: props?.subheadTextFontFamily1 || 'inter',
            linkText: props?.linkText1,
            linkUrl: props?.linkUrl1,
            linkColor: props?.linkColor1 || 'black',
            linkAriaLabel: props?.linkAriaLabel1,
            buttonUrl: props?.buttonUrl1,
            buttonText: props?.buttonText1 || '',
            buttonBgColor: props?.buttonBgColor1 || 'yellow.100',
            buttonTextColor: props?.buttonTextColor1 || 'black.300'
        },
        {
            title: props?.title2,
            titleColor: props?.titleColor2 || 'black',
            titleFontFamily: props?.titleFontFamily2 || 'caslon',
            titleTag: props?.titleTag2,
            subheadText: props?.subheadText2,
            subheadTextColor: props?.subheadTextColor2 || 'black',
            subheadTextTag: props?.subheadTextTag2,
            subheadTextFontFamily: props?.subheadTextFontFamily2 || 'inter',
            linkText: props?.linkText2,
            linkUrl: props?.linkUrl2,
            linkColor: props?.linkColor2 || 'black',
            linkAriaLabel: props?.linkAriaLabel2,
            buttonUrl: props?.buttonUrl2,
            buttonText: props?.buttonText2 || '',
            buttonBgColor: props?.buttonBgColor2 || 'yellow.100',
            buttonTextColor: props?.buttonTextColor2 || 'black.300'
        },
        {
            title: props?.title3,
            titleColor: props?.titleColor3 || 'black',
            titleFontFamily: props?.titleFontFamily3 || 'caslon',
            titleTag: props?.titleTag3,
            subheadText: props?.subheadText3,
            subheadTextColor: props?.subheadTextColor3 || 'black',
            subheadTextTag: props?.subheadTextTag3,
            subheadTextFontFamily: props?.subheadTextFontFamily3 || 'inter',
            linkText: props?.linkText3,
            linkUrl: props?.linkUrl3,
            linkColor: props?.linkColor3 || 'black',
            linkAriaLabel: props?.linkAriaLabel3,
            buttonUrl: props?.buttonUrl3,
            buttonText: props?.buttonText3 || '',
            buttonBgColor: props?.buttonBgColor3 || 'yellow.100',
            buttonTextColor: props?.buttonTextColor3 || 'black.300'
        },
        {
            title: props?.title4,
            titleColor: props?.titleColor4 || 'black',
            titleFontFamily: props?.titleFontFamily4 || 'caslon',
            titleTag: props?.titleTag4,
            subheadText: props?.subheadText4,
            subheadTextColor: props?.subheadTextColor4 || 'black',
            subheadTextTag: props?.subheadTextTag4,
            subheadTextFontFamily: props?.subheadTextFontFamily4 || 'inter',
            linkText: props?.linkText4,
            linkUrl: props?.linkUrl4,
            linkColor: props?.linkColor4 || 'black',
            linkAriaLabel: props?.linkAriaLabel4,
            buttonUrl: props?.buttonUrl4,
            buttonText: props?.buttonText4 || '',
            buttonBgColor: props?.buttonBgColor4 || 'yellow.100',
            buttonTextColor: props?.buttonTextColor4 || 'black.300'
        },
        {
            title: props?.title5,
            titleColor: props?.titleColor5 || 'black',
            titleFontFamily: props?.titleFontFamily5 || 'caslon',
            titleTag: props?.titleTag5,
            subheadText: props?.subheadText5,
            subheadTextColor: props?.subheadTextColor5 || 'black',
            subheadTextTag: props?.subheadTextTag5,
            subheadTextFontFamily: props?.subheadTextFontFamily5 || 'inter',
            linkText: props?.linkText5,
            linkUrl: props?.linkUrl5,
            linkColor: props?.linkColor5 || 'black',
            linkAriaLabel: props?.linkAriaLabel5,
            buttonUrl: props?.buttonUrl5,
            buttonText: props?.buttonText5 || '',
            buttonBgColor: props?.buttonBgColor5 || 'yellow.100',
            buttonTextColor: props?.buttonTextColor5 || 'black.300'
        },
        {
            title: props?.title6,
            titleColor: props?.titleColor6 || 'black',
            titleFontFamily: props?.titleFontFamily6 || 'caslon',
            titleTag: props?.titleTag6,
            subheadText: props?.subheadText6,
            subheadTextColor: props?.subheadTextColor6 || 'black',
            subheadTextTag: props?.subheadTextTag6,
            subheadTextFontFamily: props?.subheadTextFontFamily6 || 'inter',
            linkText: props?.linkText6,
            linkUrl: props?.linkUrl6,
            linkColor: props?.linkColor6 || 'black',
            linkAriaLabel: props?.linkAriaLabel6,
            buttonUrl: props?.buttonUrl6,
            buttonText: props?.buttonText6 || '',
            buttonBgColor: props?.buttonBgColor6 || 'yellow.100',
            buttonTextColor: props?.buttonTextColor6 || 'black.300'
        }
    ]

    const validCards = cards?.filter((card) => card?.title && card?.subheadText && card?.linkText)
    useEffect(() => {
        if (validCards?.length) {
            pdTagManager.viewComponent(typeId, name, validCards?.length)
        }
    }, [validCards?.length])
    return (
        <Box
            background={props?.background || 'white'}
            paddingTop={{md: '20px', '2xl': '30px'}}
            paddingBottom={{md: '10px', '2xl': '30px'}}
            display={props.hideOnMobile ? {base: 'none', lg: 'block'} : 'block'}
        >
            <HStack
                gap="0"
                alignItems="stretch"
                width="100%"
                maxWidth="100vw"
                sx={{
                    '.swiper': {
                        '--swiper-pagination-bottom': {base: '20px', md: 0},
                        width: '100%',
                        paddingBottom: {md: '40px', lg: '0'},

                        '&:not(.swiper-initialized)': {
                            paddingRight: 0,

                            '.swiper-wrapper': {
                                display: 'flex',
                                overflowX: 'auto'
                            },
                            '.swiper-slide': {
                                flex: '0 0 100%'
                            }
                        },

                        '&:hover': {
                            '.swiper-button-prev, .swiper-button-next': {
                                opacity: 1
                            }
                        }
                    },
                    '.swiper-slide': {
                        flex: {
                            base: '0 0 100%',
                            md: '0 0 calc(25% - 1px)',
                            lg: 1
                        },
                        borderRight: {base: 'none', md: '1px solid'},
                        borderColor: 'gray.650',

                        '&:last-child': {
                            borderRight: 'none'
                        }
                    },
                    '.swiper-pagination': {
                        display: {
                            base: 'block',
                            md: cards?.length > 4 ? 'block' : 'none',
                            lg: 'none'
                        }
                    },
                    '.swiper-button-prev, .swiper-button-next': {
                        '--swiper-navigation-size': '45px',
                        display: {base: 'none', md: 'flex'},
                        top: '50%',
                        borderRadius: '5px',
                        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.20)',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',

                        '&.swiper-button-disabled': {
                            display: 'none'
                        }
                    },
                    '.swiper-button-prev': {
                        left: '10px',
                        right: 'initial',
                        transform: 'translateY(-50%) rotate(180deg)'
                    },
                    '.swiper-button-next': {
                        right: '10px',
                        left: 'initial',
                        transform: 'translateY(-50%)'
                    }
                }}
            >
                <Swiper
                    navigation={true}
                    pagination={{
                        clickable: true
                    }}
                    modules={[Pagination, Navigation]}
                    slidesPerView={slidesPerView}
                >
                    {validCards.map((card, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <Card {...card} typeId={typeId} name={name} index={index} />
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </HStack>
        </Box>
    )
}

TextTilesX4.propTypes = {
    background: PropTypes.string,
    hideOnMobile: PropTypes.bool,

    title1: PropTypes.string,
    titleColor1: PropTypes.string,
    titleTag1: PropTypes.string,
    titleFontFamily1: PropTypes.string,
    subheadText1: PropTypes.string,
    subheadTextColor1: PropTypes.string,
    subheadTextTag1: PropTypes.string,
    subheadTextFontFamily1: PropTypes.string,
    linkText1: PropTypes.string,
    linkUrl1: PropTypes.string,
    linkColor1: PropTypes.string,
    linkAriaLabel1: PropTypes.string,
    buttonText1: PropTypes.string,
    buttonUrl1: PropTypes.string,
    buttonBgColor1: PropTypes.string,
    buttonTextColor1: PropTypes.string,

    title2: PropTypes.string,
    titleColor2: PropTypes.string,
    titleTag2: PropTypes.string,
    titleFontFamily2: PropTypes.string,
    subheadText2: PropTypes.string,
    subheadTextColor2: PropTypes.string,
    subheadTextTag2: PropTypes.string,
    subheadTextFontFamily2: PropTypes.string,
    linkText2: PropTypes.string,
    linkUrl2: PropTypes.string,
    linkColor2: PropTypes.string,
    linkAriaLabel2: PropTypes.string,
    buttonText2: PropTypes.string,
    buttonUrl2: PropTypes.string,
    buttonBgColor2: PropTypes.string,
    buttonTextColor2: PropTypes.string,

    title3: PropTypes.string,
    titleColor3: PropTypes.string,
    titleTag3: PropTypes.string,
    titleFontFamily3: PropTypes.string,
    subheadText3: PropTypes.string,
    subheadTextColor3: PropTypes.string,
    subheadTextTag3: PropTypes.string,
    subheadTextFontFamily3: PropTypes.string,
    linkText3: PropTypes.string,
    linkUrl3: PropTypes.string,
    linkColor3: PropTypes.string,
    linkAriaLabel3: PropTypes.string,
    buttonText3: PropTypes.string,
    buttonUrl3: PropTypes.string,
    buttonBgColor3: PropTypes.string,
    buttonTextColor3: PropTypes.string,

    title4: PropTypes.string,
    titleColor4: PropTypes.string,
    titleTag4: PropTypes.string,
    titleFontFamily4: PropTypes.string,
    subheadText4: PropTypes.string,
    subheadTextColor4: PropTypes.string,
    subheadTextTag4: PropTypes.string,
    subheadTextFontFamily4: PropTypes.string,
    linkText4: PropTypes.string,
    linkUrl4: PropTypes.string,
    linkColor4: PropTypes.string,
    linkAriaLabel4: PropTypes.string,
    buttonText4: PropTypes.string,
    buttonUrl4: PropTypes.string,
    buttonBgColor4: PropTypes.string,
    buttonTextColor4: PropTypes.string,

    title5: PropTypes.string,
    titleColor5: PropTypes.string,
    titleTag5: PropTypes.string,
    titleFontFamily5: PropTypes.string,
    subheadText5: PropTypes.string,
    subheadTextColor5: PropTypes.string,
    subheadTextTag5: PropTypes.string,
    subheadTextFontFamily5: PropTypes.string,
    linkText5: PropTypes.string,
    linkUrl5: PropTypes.string,
    linkColor5: PropTypes.string,
    linkAriaLabel5: PropTypes.string,
    buttonText5: PropTypes.string,
    buttonUrl5: PropTypes.string,
    buttonBgColor5: PropTypes.string,
    buttonTextColor5: PropTypes.string,

    title6: PropTypes.string,
    titleColor6: PropTypes.string,
    titleTag6: PropTypes.string,
    titleFontFamily6: PropTypes.string,
    subheadText6: PropTypes.string,
    subheadTextColor6: PropTypes.string,
    subheadTextTag6: PropTypes.string,
    subheadTextFontFamily6: PropTypes.string,
    linkText6: PropTypes.string,
    linkUrl6: PropTypes.string,
    linkColor6: PropTypes.string,
    linkAriaLabel6: PropTypes.string,
    buttonText6: PropTypes.string,
    buttonUrl6: PropTypes.string,
    buttonBgColor6: PropTypes.string,
    buttonTextColor6: PropTypes.string,
    name: PropTypes.any,
    typeId: PropTypes.string
}

export default TextTilesX4
